import React from 'react';
import { IconButton } from '@mui/material';
import { ACTIVE_BUTTON_COLOR, FONT_COLOR_DISABLED } from '../utils';

export interface CustomIconButtonProps {
	isActive?: boolean;
	label: string;
	onClick: () => void;
	icon: React.ReactElement;
	size?: 'small' | 'medium' | 'large' | undefined;
	isButtonAvailable: boolean;
	fontSize?: string;
}

export const CustomIconButton: React.FC<CustomIconButtonProps> = ({
	isActive,
	label,
	onClick,
	icon,
	size,
	isButtonAvailable,
	fontSize,
}) => {
	const className = () => {
		if (!isButtonAvailable) {
			return 'disabled-custom-icon-button';
		}
		return isActive ? 'active-custom-icon-button' : 'custom-icon-button';
	};

	let color = isActive ? '#00b687' : ACTIVE_BUTTON_COLOR;

	if (!isButtonAvailable) {
		color = FONT_COLOR_DISABLED;
	}

	return (
		<IconButton
			size={size || 'small'}
			className={className()}
			style={{
				color,
				backgroundColor: 'initial',
				marginLeft: 5,
				padding: '0 0',
				borderRadius: 2,
			}}
			onClick={onClick}
		>
			{icon}
			<div
				className={className()}
				style={{ fontSize: fontSize || 'font-size: 18px' }}
			>
				{label}
			</div>
		</IconButton>
	);
};
